import { render, staticRenderFns } from "./AthleteVerifiedAssessmentsCard.vue?vue&type=template&id=5bccde10&scoped=true&"
import script from "./AthleteVerifiedAssessmentsCard.vue?vue&type=script&lang=ts&"
export * from "./AthleteVerifiedAssessmentsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bccde10",
  null
  
)

export default component.exports